import React, { useEffect, useRef, useState } from 'react';
import './InfoPopup.scss';
import './CommentPopup.scss';
import { ReactComponent as AlertTriangle } from '../../images/alert-triangle.svg';

interface InfoPopupProps {
  trigger: React.ReactNode;
  className?: string;
  messages?: Record<string, string>;
  onToggle?: (isOpen: boolean) => void; // Callback to notify parent about toggle state
}

const InfoPopup: React.FC<InfoPopupProps> = ({ trigger, className, messages, onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setIsOpen(false);
        if (onToggle) {
          onToggle(false); // Notify parent that popup is closed
        }
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onToggle]);

  const handleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (onToggle) {
      onToggle(newState); // Notify parent about the new state
    }
  };

  return (
    <>
      <div onClick={handleToggle} className='info-popup-trigger'>
        {trigger}
      </div>

      {isOpen && (
        <div className='comment-popup-overlay'>
          <div ref={popupRef} className={`info-popup-box ${className || ''}`}>
            <div className='info-popup-section'>
              <div className='info-popup-header'>Test not analyzable</div>
              <div className='info-popup-content'>
                Check validations messages and Completions tab for any warning or error messages.
              </div>
            </div>

            <div className='info-popup-section bordered-section'>
              <div className='info-popup-header'>Test validation messages</div>
              <div className='info-popup-content'>
                <div className='info-popup-content'>
                  {messages?.validationMessage
                    ? Object.entries(JSON.parse(messages.validationMessage)).map(([key, message]) => (
                        <div key={key} className='info-popup-line'>
                          <AlertTriangle className='triangle-alert-icon' />
                          <span>{message as string}</span>
                        </div>
                      ))
                    : 'Test requires processing'}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InfoPopup;
